import { makeStyles } from '@material-ui/core/styles'

export const useExpertiseStyles = makeStyles((theme) => ({
    item: {
        width: '100%',
        padding: theme.spacing(3),
        margin: theme.spacing(2, 0),
        // border: '1px solid #bdbdbd',
        '&:hover': {
            border: `1px solid ${theme.palette.primary.main}`,
        },
    },
    icon: {
        marginRight: theme.spacing(1),
        width: 40,
        height: 40,
        backgroundColor: '#ece9e9',
        transition: '0.3s',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
        },
    },
    recentTime: {
        position: 'absolute',
        top: 2,
        right: 4,
        color: 'grey',
    },

    header: {
        fontWeight: 'bold',
    },
    btnEdit: {
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
        height: '44px',
        marginRight: '1px',
    },
    btnDelete: {
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
        height: '45px',
        marginRight: '1px',
        marginBottom: '-2px',
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.background.default,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    multiLineEllipsis: {
        maxWidth: '100%',
        whiteSpace: 'pre-wrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': 1,
        '-webkit-box-orient': 'vertical',
    },
}))